<section *ngIf="!isLoading">
    <div *ngIf="planDetails.isActiveUnlimitedPlan; else byTheGigOrTabletActivePlan">
        <div class="plan-details">
            <div class="info">
                <div class="info-icon">
                    <xm-media-image aria-hidden="true" [imageOptions]="miniIcon"></xm-media-image>
                </div>
                <div class="data">
                    <h4 class="plan-name">{{ planDetails.currentPlan.planCardContent.header }}</h4>
                    <span *ngIf="!planDetails.currentPlan.planCardContent?.strikeThroughSubheader" class="plan-price">{{ planDetails.currentPlan.planCardContent.subheader }}</span>
                    <div *ngIf="isCBMGeminiEnabled && planDetails.currentPlan.planCardContent?.strikeThroughSubheader" class="plan-pricing">
                        <span class="plan-price-gemini strike-through">{{ planDetails.currentPlan.planCardContent.strikeThroughSubheader }}</span>
                        <span class="plan-price-gemini">{{ planDetails.currentPlan.planCardContent.subheader }}</span>
                    </div>
                    <p class="plan-subheader">{{ planDetails.currentPlan.planCardContent.body }}</p>
                </div>
                <div *ngIf="planDetails.currentPlan.planCardContent.badge" class="action" role="status" [attr.aria-label]="planDetails.currentPlan.planCardContent.header + ' is ' + inUse">
                    <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                    <span class="action-text">{{ inUse }}</span>
                </div>
            </div>
            <!-- Displaying promo container temp. Needs to be replaced post CEUIDSS-29611 & CEUIDSS-29620 completion -->
            <div class="features" *ngIf="(shouldAccountShowPromotion || linePromotion?.length || tradeInDDAPromo?.length || extendedPromoDollar?.length) && !showPlanSixTabletSection && !isIcopPlanSwitch && !accountSummary.level6Customer && !isCBMGeminiEnabled"> 
                <div class="active-plan-feature">
                    <div class="features-content">
                        <xm-media-image aria-hidden="true" [imageOptions]="promotionIcon" class="promotion-icon"></xm-media-image>
                        <div class="promotion">
                            <div *ngIf="shouldAccountShowPromotion">
                                <xm-promotions *ngFor="let promo of accountPromotion" [header]="servicePromotions.promoAccountHeader" [subheader]="promoAccountSubheader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                                </xm-promotions>
                            </div>
                            <div *ngIf="linePromotion?.length">
                                <xm-promotions *ngFor="let promo of linePromotion" [header]="promotionLineHeader(promo)" [subheader]="promotionLineSubheader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                                </xm-promotions>
                            </div>
                            <div *ngIf="tradeInDDAPromo?.length">
                                <xm-promotions *ngFor="let promo of tradeInDDAPromo" [header]="promotionTradeInDDAHeader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                                </xm-promotions>
                            </div>
                            <div *ngIf="extendedPromoDollar?.length">
                                <xm-promotions *ngFor="let promo of extendedPromoDollar" [header]="promotionExtendedDollarDDAHeader(promo)" [imageOptions]="promotionIcon" class="promo-content">
                                </xm-promotions>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="features" *ngIf="((isIcopPlanSwitch && planDetails.promotionContent.length > 0) || (this.accountSummary.level6Customer && planDetails.promotionContent.length > 0)) && !(isCBMGeminiEnabled)"> 
                <div class="active-plan-feature">
                    <div class="features-content">
                        <div class="promotion">
                            <div class="icop-line-promotions" *ngFor="let linePromoContent of planDetails.promotionContent">
                                <xm-media-image aria-hidden="true" [imageOptions]="getPromoIcon(linePromoContent.icon)" class="promotion-icon"></xm-media-image>
                                <div class="promotion-content">
                                    <span class="header">{{ linePromoContent.header }}</span>
                                    <div *ngIf="linePromoContent.body" class="description">{{ linePromoContent.body }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="features" *ngIf="(isCBMGeminiEnabled && planDetails.promotionContent.length > 0)"> 
                <div class="active-plan-feature-gemini">
                    <div class="features-content">
                        <div class="promotion">
                            <div class="icop-line-promotions" *ngFor="let linePromoContent of planDetails.promotionContent; let promoIndex = index">
                                <xm-media-image aria-hidden="true" [imageOptions]="getPromoIcon(linePromoContent.icon)" class="promotion-icon"></xm-media-image>
                                <div class="promotion-content">
                                    <button type="button" class="xm-btn-link-light promotion-toggle" (click)="togglePromotion(promoIndex)" [attr.aria-expanded]="promotionExpanded[promoIndex] || false">
                                        <span class="header">{{ linePromoContent.header }}</span>
                                        <xm-media-image class="expand-icon" [ngClass]="{'expanded': promotionExpanded[promoIndex]}" [imageOptions]="caretIcon" size="height" aria-hidden="true"></xm-media-image>
                                    </button>
                                    <span *ngIf="linePromoContent.subheader" class="sub-header-gemini">{{ linePromoContent.subheader }}</span>
                                    <xm-expandable [expanded]="promotionExpanded[promoIndex]">
                                        <div *ngIf="linePromoContent.body" class="description">{{ linePromoContent.body }}</div>
                                    </xm-expandable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="planDetails.eligiblePlans.Unlimited.length > 0">
                <div class="features" *ngFor="let plan of planDetails.eligiblePlans.Unlimited">
                    <div class="active-plan-feature">
                        <h4 class="feature-header">
                            {{ plan.planCardContent.header }}
                        </h4>
                        <div class="features-content">
                            <div class="plan-feature">
                                <xm-media-image aria-hidden="true" [imageOptions]="dataIcon"
                                    class="plan-feature-icon"></xm-media-image>
                                <div class="plan-feature-description">
                                    <h4 class="plan-feature-header">{{ plan.planCardContent.subheader }}</h4>
                                    <p class="plan-feature-subheader" *ngIf="!isArray(plan?.planCardContent?.body)">{{ plan.planCardContent.body }}</p>
                                    <ul class="plan-feature-subheader" *ngIf="isArray(plan?.planCardContent?.body)">
                                        <li *ngFor="let item of plan.planCardContent.body">{{ item }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shared-data-cta">
                        <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="plan.promiseBtn" (promiseClick)="getLineSwitchEligibility(plan.planCode, plan.planName, plan)" [disabled]="shouldDisableButton" [ngClass]="{'disabled': shouldDisableButton}"><span>{{ plan.planCardContent.cta.content }}</span></button>
                        <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="planDetails.eligiblePlans.BTG.length > 0 && isBTGScheduledSwitch">
            <div class="plan-details">
                <div class="info">
                    <div class="info-icon">
                        <xm-media-image aria-hidden="true" [imageOptions]="byTheGigIcon"></xm-media-image>
                    </div>
                    <div class="data">
                        <h4 class="plan-name">{{ btgPlanDetails?.planCardContent.header }}</h4>
                        <span class="plan-price">{{ btgPlanDetails?.planCardContent.subheader }}</span>
                        <p class="plan-subheader">{{ btgPlanDetails?.planCardContent.body }}</p>
                    </div>
                </div>
                <div class="features">
                    <div class="active-plan-feature">
                        <h4 class="feature-header">
                            {{ btgScheduledSwitchContent?.planCardContent.header }}
                        </h4>
                        <div class="features-content">
                            <div class="plan-feature">
                                <xm-media-image aria-hidden="true" [imageOptions]="dataIcon"
                                    class="plan-feature-icon"></xm-media-image>
                                <div class="plan-feature-description">
                                    <h4 class="plan-feature-header">{{ btgScheduledSwitchContent?.planCardContent.subheader }}</h4>
                                    <p class="plan-feature-subheader">{{ btgScheduledSwitchContent?.planCardContent.body }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shared-data-cta">
                        <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="btgScheduledSwitchContent.promiseBtn" (promiseClick)="getLineSwitchEligibility(btgScheduledSwitchContent?.planCode, btgScheduledSwitchContent?.planName, btgScheduledSwitchContent)" [disabled]="shouldDisableButton" [ngClass]="{'disabled': shouldDisableButton}"><span>{{ btgScheduledSwitchContent?.planCardContent.cta.content }}</span></button>
                        <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="plan-details" *ngIf="planDetails.eligiblePlans.BTG.length > 0 && !isBTGScheduledSwitch">
            <div *ngFor="let plan of planDetails.eligiblePlans.BTG">
                <div class="info">
                    <div class="info-icon">
                        <xm-media-image aria-hidden="true" [imageOptions]="byTheGigIcon"></xm-media-image>
                    </div>
                    <div class="data">
                        <h4 class="plan-name">{{ plan.planCardContent.header }}</h4>
                        <span class="plan-price">{{ plan.planCardContent.subheader }}</span>
                        <p class="plan-subheader">{{ plan.planCardContent.body }}</p>
                    </div>
                    <div class="shared-data-cta">
                        <button id="switch-shared-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="plan.promiseBtn" (promiseClick)="getLineSwitchEligibility(plan.planCode, plan.planName, plan)" [disabled]="shouldDisableButton" [ngClass]="{'disabled': shouldDisableButton}"><span>{{ plan.planCardContent.cta.content }}</span></button>
                        <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #byTheGigOrTabletActivePlan>
        <div *ngIf="planDetails.isBTGActivePlan">
            <div class="plan-details">
                <div class="info">
                    <div class="info-icon">
                        <xm-media-image aria-hidden="true" [imageOptions]="byTheGigIcon"></xm-media-image>
                    </div>
                    <div class="data">
                        <h4 class="plan-name">{{ planDetails.currentPlan.planCardContent.header }}</h4>
                        <span class="plan-price">{{ planDetails.currentPlan.planCardContent.subheader }}</span>
                        <p class="plan-subheader">{{ planDetails.currentPlan.planCardContent.body }}</p>
                    </div>
                    <div *ngIf="planDetails.currentPlan.planCardContent.badge" class="action" role="status" [attr.aria-label]="planDetails.currentPlan.planCardContent.header + ' is ' + inUse">
                        <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                        <span class="action-text">{{ inUse }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="planDetails.eligiblePlans.Unlimited.length > 0">
                <div class="plan-details" *ngFor="let plan of planDetails?.eligiblePlans.Unlimited">
                    <div class="info">
                        <div class="info-icon">
                            <xm-media-image aria-hidden="true" [imageOptions]="miniIcon"></xm-media-image>
                        </div>
                        <div class="data">
                            <h4 class="plan-name">{{ plan.planCardContent.header }}</h4>
                            <span class="plan-price">{{ plan.planCardContent.subheader }}</span>
                            <p class="plan-subheader">{{ plan.planCardContent.body }}</p>
                        </div>
                        <div class="shared-data-cta">
                            <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="plan.promiseBtn" (promiseClick)="getLineSwitchEligibility(plan.planCode, plan.planName, plan)" [disabled]="shouldDisableButton" [ngClass]="{'disabled': shouldDisableButton}"><span>{{ plan.planCardContent.cta.content }}</span></button>
                            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="planDetails.isTabletActivePlan && !isBusinessUser">
            <div class="plan-details">
                <div class="info">
                    <div class="tablet-info-icon">
                        <xm-media-image aria-hidden="true" [imageOptions]="tabletIcon" size="width"></xm-media-image>
                    </div>
                    <div class="data">
                        <h4 class="plan-name">{{ planDetails.currentPlan.planCardContent.header }}</h4>
                        <span class="plan-price">{{ planDetails.currentPlan.planCardContent.subheader }}</span>
                        <p class="plan-subheader">{{ planDetails.currentPlan.planCardContent.body }}</p>
                    </div>
                    <div *ngIf="planDetails.currentPlan.planCardContent.badge" class="action" role="status" [attr.aria-label]="planDetails.currentPlan.planCardContent.header + ' is ' + inUse">
                        <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                        <span class="action-text">{{ inUse }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="planDetails.isTabletActivePlan && isBusinessUser">
            <div class="plan-details">
                <div class="info">
                    <div class="tablet-info-icon">
                        <xm-media-image aria-hidden="true" [imageOptions]="tabletIcon" size="width"></xm-media-image>
                    </div>
                    <div class="data">
                        <h4 class="plan-name">{{ planDetails.currentPlan.planCardContent.header }}</h4>
                        <span class="plan-price">{{ planDetails.currentPlan.planCardContent.subheader }}</span>
                        <p class="plan-subheader">{{ planDetails.currentPlan.planCardContent.body }}</p>
                    </div>
                    <div *ngIf="planDetails.currentPlan.planCardContent.badge" class="action" role="status" [attr.aria-label]="planDetails.currentPlan.planCardContent.header + ' is ' + inUse">
                        <xm-media-image [imageOptions]="inUseIcon" class="use-icon" center="auto" size="auto"></xm-media-image>
                        <span class="action-text">{{ inUse }}</span>
                    </div>
                </div>
                <div *ngIf="planDetails.eligiblePlans.Unlimited.length > 0">
                    <div class="features" *ngFor="let plan of planDetails.eligiblePlans.Unlimited">
                        <div class="active-plan-feature">
                            <h4 class="feature-header">
                                {{ plan.planCardContent.header }}
                            </h4>
                            <div class="features-content">
                                <div class="plan-feature">
                                    <xm-media-image aria-hidden="true" [imageOptions]="dataIcon"
                                        class="plan-feature-icon"></xm-media-image>
                                    <div class="plan-feature-description">
                                        <h4 class="plan-feature-header">{{ plan.planCardContent.subheader }}</h4>
                                        <p class="plan-feature-subheader">{{ plan.planCardContent.body }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="shared-data-cta">
                            <button id="switch-unlimited-plan" class="xm-btn-secondary-light promise-btn" [promiseBtn]="plan.promiseBtn" (promiseClick)="getLineSwitchEligibility(plan.planCode, plan.planName, plan)" [disabled]="shouldDisableButton" [ngClass]="{'disabled': shouldDisableButton}"><span>{{ plan.planCardContent.cta.content }}</span></button>
                            <span class="error" *ngIf="planEligibilityFail">{{ errorText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</section>
<section *ngIf="isLoading">
    <xm-loader-overlay type="plan-data-options"></xm-loader-overlay>
</section>
